export default {
    ARIATemplate: {
        type: String,
        default: undefined
    }, 
    culture: {
        type: String,
        default: undefined
    }, 
    dates: {
        type: Array,
        default: undefined
    }, 
    depth: {
        type: String,
        default: undefined
    }, 
    disableDates: {
        type: [Array, Function],
        default: undefined
    }, 
    footer: {
        type: [String, Function],
        default: undefined
    }, 
    format: {
        type: String,
        default: undefined
    }, 
    max: {
        type: Date,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    min: {
        type: Date,
        default: undefined
    }, 
    month: {
        type: Object,
        default: undefined
    }, 
    labels: {
        type: Boolean,
        default: undefined
    }, 
    weekNumber: {
        type: Boolean,
        default: undefined
    }, 
    range: {
        type: Object,
        default: undefined
    }, 
    start: {
        type: String,
        default: undefined
    }, 

    // Events
    change: Function, 
    close: Function, 
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/DateRangePickerProps.js